import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const useAzureConfig = () => {
    const [config, setConfig] = React.useState();
    const [ok, setOk] = React.useState(false);
    const [erro, setErro] = React.useState();

    React.useEffect(() => {
        const loadAsync = async () => {
            try{
                const sessionConfig = sessionStorage.getItem("config");
                if (sessionConfig) {
                setConfig(JSON.parse(sessionConfig));
                return;
                }

                const response = await fetch("/api/info");
                
                if (!response.ok) {
                    setErro(response)
                    throw new Error(response.status);
                }
                
                const ret = await response.json();
                window.info = ret;
                
                setOk(true);
                
                // if( ret && ret.azure){
                //     const json = {
                //         auth: {
                //             clientId: ret.azure.clientId, //"20b86767-55c9-41fa-888f-cb3a958ea6c4",
                //             authority: ret.azure.uri, //"https://login.microsoftonline.com/7138408e-9fd9-4e00-9834-c2c0ecca6870",
                //             redirectUri: "/"
                //         }
                //     }
                //     setConfig(json);
                //     sessionStorage.setItem("config", JSON.stringify(json));
                // }else{
                    setConfig(ret);
                // }
            }catch(erro){
                console.error( erro );
            }
        };
        loadAsync();
    }, []);

    return [config, ok, erro];
};

export default useAzureConfig;